var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isProduction)?_c('Badge',{class:_vm.$style.environmentBadge},[_c('Typography',{attrs:{"variant":_vm.TYPOGRAPHY_TYPES.bodySmallRegular}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }